// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LatticeModal_wrapper__R60B7"};